import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import HomePage from "./HomePage";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-cards";
import "swiper/css/effect-coverflow";

import "react-loading-skeleton/dist/skeleton.css";

import "./styles.css";

import PetDetailWrapper from "./PetDetailWrapper.tsx";
import { PAGE_PATHS } from "./config.ts";
import { ShowPets } from "./ShowPets.tsx";

const links = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: PAGE_PATHS.PET_DETAIL,
    element: <PetDetailWrapper />,
  },
  {
    path: PAGE_PATHS.CATS,
    element: (
      <ShowPets
        petType="cat"
        display={"carousel"}
        title={"Cats"}
        allPetsLink={PAGE_PATHS.ALL_CATS}
      />
    ),
  },
  {
    path: "/cats-filterable-carousel",
    element: (
      <ShowPets petType="cat" display={"filterable-carousel"} title={"Cats"} />
    ),
  },
  {
    path: PAGE_PATHS.DOGS,
    element: (
      <ShowPets
        petType="dog"
        display={"carousel"}
        title={"Dogs"}
        allPetsLink={PAGE_PATHS.ALL_DOGS}
      />
    ),
  },
  {
    path: PAGE_PATHS.CRITTERS,
    element: (
      <ShowPets
        petType="small"
        display={"carousel"}
        title={"Critters"}
        allPetsLink={PAGE_PATHS.ALL_CRITTERS}
      />
    ),
  },
  {
    path: PAGE_PATHS.ALL_CATS,
    element: <ShowPets petType="cat" display={"grid"} />,
  },
  {
    path: PAGE_PATHS.ALL_DOGS,
    element: <ShowPets petType="dog" display={"grid"} />,
  },
  {
    path: PAGE_PATHS.ALL_CRITTERS,
    element: <ShowPets petType="small" display={"grid"} />,
  },
  {
    path: PAGE_PATHS.ADOPTED,
    element: (
      <ShowPets
        petType="adopted"
        display={"carousel"}
        title={"Adopted"}
        allPetsLink={PAGE_PATHS.ADOPTED}
      />
    ),
  },
  {
    path: PAGE_PATHS.ALL_ADOPTED,
    element: <ShowPets petType="adopted" display={"grid"} />,
  },
  {
    path: PAGE_PATHS.ALL_HOMEPAGE,
    element: (
      <ShowPets
        petType="all"
        display={"filterable-carousel"}
        // title={'Adopted'}
        // allPetsLink={PAGE_PATHS.ADOPTED}
      />
    ),
  },
];

export default function App() {
  return (
    <div className="App">
      <div className="flex flex-wrap gap-2 my-2 md:my-4">
        {links.map(({ path }) => (
          <div key={path} className="mx-1">
            <a href={path}>{path}</a>
          </div>
        ))}
      </div>

      <div>
        <Router>
          <Routes>
            {links.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>
        </Router>
        <Outlet />
      </div>
    </div>
  );
}
